<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{on, attrs}">
        <v-text-field
          dense
          :label="label"
          type="string"
          outlined
          readonly
          v-model="descPlan"
          :append-icon="
            !readonly && value && value.id ? 'fa-window-close' : undefined
          "
          @click:append="$emit('selected', {})"
          :error-messages="errorMessages"
          :append-outer-icon="!readonly ? 'fa-search' : undefined"
          @click:append-outer="productSearch"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <span>{{ descPlan }}</span>
    </v-tooltip>

    <product-search
      ref="productSearch"
      @selected="selectPlan"
      title="Selecione um Plano"
      :single="true"
    ></product-search>
  </div>
</template>

<script>
import ProductSearch from '@/view/equivalence_configuration/components/dlg_product_search';

export default {
  components: {ProductSearch},

  props: {
    label: {
      type: String,
    },
    ßonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
    },
    errorMessages: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
  },

  data() {
    return {
      plan: null,
    };
  },

  computed: {
    descPlan() {
      return this.value && this.value.id
        ? `${this.value.productCode}-${this.value.description}`
        : 'Selecione...';
    },
  },

  methods: {
    goBack() {
      this.$router.back();
    },

    selectPlan(products) {
      this.$emit('selected', products);
    },
    productSearch(evt) {
      this.$refs.productSearch.show();
    },
  },
};
</script>
<style scoped>
</style>